import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";
import { AdminService } from "src/app/shared/services/admin/admin.service";
import {
  courseTeachersListLoad,
  courseTeachersListLoadFail,
  courseTeachersListLoadSuccess,
} from "../../actions/admin/course-teachers.actions";
import { Store } from "@ngrx/store";
import { AdminCourseList } from "../../reducers/admin/course-admin.reducer";
import { adminAllCourseSelectors } from "../../selectors/course-admin.selectors";
import { SubscriptionOrganization } from "src/app/shared/interfaces/orgadmin/course-organization";

@Injectable()
export class CourseTeachersEffect {
  getInvitedTeachersList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(courseTeachersListLoad),
      withLatestFrom(this.store.select(adminAllCourseSelectors)),
      switchMap(([{ organizationId, subId }, subscriptions]) => {
        const subscription = subscriptions.find((sub) => sub.id === subId);

        return subscription
          ? of(courseTeachersListLoadSuccess({ teachersList: subscription }))
          : this.adminService.getSingleSubscription(organizationId, subId).pipe(
              map((res: SubscriptionOrganization) =>
                courseTeachersListLoadSuccess({ teachersList: res }),
              ),
              catchError(({ error }) => of(courseTeachersListLoadFail(error))),
            );
      }),
    ),
  );

  constructor(
    private adminService: AdminService,
    private actions$: Actions,
    private store: Store<{ course: AdminCourseList }>,
  ) {}
}
